import React from 'react'
import { ChatBreakoutSquare, CommandIcon, LikeIcon, LoadingIcon, MessageChatCircle, MessageHeartIcon, MessageSmileCircle, Zap } from '../../../icons'

const TipCard = ({ icon, title, detail }) => {
    return (
        <div className="flex flex-col gap-[20px] w-full items-center">
            <div className="flex items-center justify-center p-[12px] rounded-[10px] border-[1px] border-[#EAECF0] w-fit">
                {icon}
            </div>
            <div className="flex flex-col gap-[8px] items-center">
                <span className='text-[#101828] text-[20px] font-bold text-center'>
                    {title}
                </span>
                <p className='text-[16px] text-[#475467] text-center'>
                    {detail}
                </p>
            </div>
        </div>
    )
}

const HealthTips = () => {
    return (
        <div className='flex flex-col py-[96px] px-[7.7vw] gap-[64px]  items-center max-w-[1980px]'>
            <div className="flex flex-col gap-[20px] items-center max-w-[768px]">
                <div className="flex flex-col gap-[12px] items-center">
                    <span className='text-[#1C9943] font-[600] text-center'>
                        Inner Health
                    </span>
                    <h2 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] text-center'>
                        Explore The World of inner Health
                    </h2>
                </div>
                <span className='text-[#475467] sm:text-[20px] text-[16px] text-center'>
                    Navigating the Path to Personal Well-being
                </span>
            </div>
            <div className="flex flex-col gap-[32px]">
                <div className="grid lg:grid-cols-3 gap-[32px] md:grid-cols-2 grid-cols-1">
                    <TipCard icon={<CommandIcon iconColor={'#1C9943'} />} title={'Food a powerful remedy'} detail={'kick junk food to the curb and start eating foods that boost metabolism – suddenly you feel healthier, toned, energised, confident and well.'} />
                    <TipCard icon={<Zap className={''} iconColor={'#1C9943'} />} title={'Nutrition-Rich'} detail={'Remember not all foods are equal the power of wholesome nutrition  will energize and revitalise your body  helping you to look fitter, younger with the least possible effort and sacrifice.'} />
                    <TipCard icon={<LoadingIcon iconColor={'#1C9943'} />} title={'Detoxify purify'} detail={'Un-dunk-ify your diet by eating foods that support a vibrant healthy lifestyle helping to clear toxins from within the body for optimal health'} />
                </div>
                <div className="flex items-center w-full max-md:flex-col gap-[32px]">
                    <TipCard icon={<ChatBreakoutSquare iconColor={'#1C9943'} />} title={'Plant-based Supa-Foods'} detail={'Remember not all foods are equal the power of wholesome carbohydrate will energise and revitalise your body  helping you to look fitter, younger with the least possible effort and sacrifice.'} />
                    <TipCard icon={<LikeIcon className={'!w-[24px] !h-[24px]'} iconColor={'#1C9943'} />} title={' Live Analytics & Invoicing'} detail={'Empower your DJ business with real-time analytics and live invoicing. Track your gigs’ success and manage payments seamlessly, all in one place.'} />
                </div>
            </div>
        </div>
    )
}

export default HealthTips